import { Component } from '@angular/core';
@Component({
  selector: 'test-core-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {}
